import React, {Component} from 'react';
import Drawer from 'material-ui/Drawer';
import Menu from 'components/Menu';
import AppBar from 'material-ui/AppBar';

import logo from 'components/logo.png';


export default class MyDrawer extends Component {
    render() {
        return (
            <Drawer {...this.props}>
                <AppBar iconElementLeft={<img width={50} alt="Vocabulary Miner" src={logo} />} title={"Vocabulary Miner"} titleStyle={{fontSize: '21px', color: '#000'}}/>
                <Menu handleClose={this.props.handleClose}/>
            </Drawer>
        );
    }
}





// WEBPACK FOOTER //
// ./src/components/Drawer.js